import React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { formatAmount } from 'utils';
import { useAppSelector } from 'store/hooks';
import { selectTradingAccount } from '../reducers/selectors';
const BalanceInfoText = () => {
    const tradingAccount = useAppSelector(selectTradingAccount);
    if (!tradingAccount?.account.availableToInvest) {
        return null;
    }
    return (<View style={styles.container}>
      <Text TextThin-16 Secondary centered>
        Your available cash balance is{' '}
        {formatAmount(tradingAccount?.account.availableToInvest.value, tradingAccount?.account.availableToInvest.currency, 2)}
      </Text>
    </View>);
};
export default BalanceInfoText;
const styles = StyleSheet.create({
    container: {
        marginBottom: rem(16),
    },
});
